import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InterventiService } from 'src/app/services/interventi.service';
import { StatiIntervento } from '../elenco-interventi/elenco-interventi.component';

@Component({
  selector: 'app-cambio-stato-dialog',
  templateUrl: './cambio-stato-dialog.component.html',
  styleUrls: ['./cambio-stato-dialog.component.css']
})
export class CambioStatoDialogComponent implements OnInit, AfterViewInit {

  fromElencoInterventi: boolean = false;
  operazioneDaEffettuare: string = "";
  isRimodulazione: boolean = false;
  tipologiaRimodulazione: ModelEventiCalamitosi.TipologiaRimodulazioneDto[] = []
  motivazioneIntervento:string = "";

  datiOperazioneInCorso:ModelEventiCalamitosi.DatiOperazioneInterventoDTO = {
    motivazioneOperazione:null,
    descrRimodulazione:null,
    importoRimodulazione:null,
    tipologiaRimodulazione:null
  };

  public form: FormGroup
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private interventiService: InterventiService,
    private dialogRef: MatDialogRef<CambioStatoDialogComponent>) {
    if (data.tipoVista === 'elenco-interventi') {
      this.fromElencoInterventi = true
    }
    //Caso Rimodulazione
    if (data.operazione === 7) {
      this.isRimodulazione = true;
      this.interventiService.getListaTpRimodulazioni().subscribe( res => {
        this.tipologiaRimodulazione = res;
      })

        this.form = new FormGroup({
          tipologiaRimodulazione: new FormControl(null, Validators.required),
          nuovoImporto: new FormControl(null, Validators.required),
          descrizioneRimodulazione: new FormControl(null, Validators.required)
        });
    }

    this.operazioneDaEffettuare = (this.interventiService.getOperazioni())[data.operazione - 1].descOperazione
    dialogRef.disableClose = true;
  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  confirmRimodulazione() {
    if(this.form.valid){
      this.datiOperazioneInCorso.descrRimodulazione = this.form.controls.descrizioneRimodulazione.value;
      this.datiOperazioneInCorso.tipologiaRimodulazione = this.form.controls.tipologiaRimodulazione.value;
      this.datiOperazioneInCorso.importoRimodulazione = this.form.controls.nuovoImporto.value;
      this.dialogRef.close(this.datiOperazioneInCorso);
    }
    else this.markAsTouched(this.form);
  }

  confirmOperazione() {
      this.datiOperazioneInCorso.motivazioneOperazione = this.motivazioneIntervento;
      this.dialogRef.close(this.datiOperazioneInCorso);
  }

  private markAsTouched(form: FormGroup) {
    for (const key in form.controls) {
      form.get(key).markAsTouched();
    }
  }
}
